import { useAuthStore } from '@/modules/auth/store/auth';
import { useCartStore } from '@/store/cart';
import { storeToRefs } from 'pinia';

/**
 * Loads customer carts once the auth session is ready.
 * A one-shot check at plugin init is not enough: after a full page refresh,
 * `authenticated` is often restored asynchronously, so we watch until we can fetch.
 */
export default defineNuxtPlugin(() => {
  const { fetchCarts } = useCart();
  const cartStore = useCartStore();
  const { cartsLoaded } = storeToRefs(cartStore);
  const authState = useAuthState();
  const authStore = useAuthStore();
  const { user, isCustomer } = storeToRefs(authStore);

  const shouldLoadCarts = computed(() => {
    if (authState.status.value !== 'authenticated') return false;
    if (cartsLoaded.value) return false;
    if (isCustomer.value && !user.value?.accountable_id) return false;
    return true;
  });

  watch(
    shouldLoadCarts,
    async (ready) => {
      if (!ready) return;
      await fetchCarts();
    },
    { immediate: true }
  );
});
